import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectssmartworld } from "../../../../data/projects/smartworld/data";

export const SmartWorldOneDXP = () => {
  const {
    smartworld_onedxp: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectssmartworld;

  return (
    <>
      <Helmet>
        <title>Smartworld One DXP, Sector 113, Gurgaon | Smart Luxury Residences</title>

        <meta
          name="description"
          content="Discover Smartworld One DXP in Sector 113, Gurgaon – cutting-edge smart residences with modern architecture, premium amenities, and excellent connectivity. Secure your dream home today!"
        />

        <meta
          name="keywords"
          content="Smartworld One DXP, Smartworld One DXP Sector 113 Gurgaon, luxury apartments Gurgaon, Smartworld One DXP price, Smartworld One DXP floor plan, smart homes Gurgaon, premium residences Gurgaon, high-tech apartments Gurgaon"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/smartworld-one-dxp-sector113-gurgaon"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
